


































import { Guid } from 'guid-typescript'
import { Component, Emit, Mixins, Prop, Ref, VModel } from 'vue-property-decorator'

import { errorNotificationWrapper, warningNotificationWrapper } from '../../logic/helpers/NotificationService'
import FileApi from '../File/logic/file-api'
import { FileStatus, FileType, MediaFileData } from '../File/types'
import { MessageEditorWithMediaProps } from '../MessageEditorWithMedia/mixins/mixins'
import MiniPopup from '../MiniPopup/MiniPopup.vue'
import CheckboxInput from '../Pi/fields/CheckboxInput/CheckboxInput.vue'
import RadioInput from '../Pi/fields/RadioInput/RadioInput.vue'
import ZoomableImage from '../ZoomableImage/ZoomableImage.vue'
import FileDataFabric from './FileDataFabric'
import currentBrowser from './currentBrowser'

@Component({
  components: {
    ZoomableImage,
    MiniPopup,
    RadioInput,
    CheckboxInput,
  },
})
export default class MediaUploader extends Mixins<MessageEditorWithMediaProps>(MessageEditorWithMediaProps) {
  @VModel() actualFilesData!: Array<MediaFileData>

  @Ref('fileInput') readonly fileInput!: HTMLInputElement

  @Ref('droppable-zone') readonly droppableZone!: HTMLElement

  @Prop({ required: false }) selectedType!: FileType

  @Prop({ required: false, type: String }) acceptedTypes!: string

  @Prop({ required: false, type: Boolean }) multipleUpload!: boolean

  @Emit('fileLoaded')
  fileLoaded(uploadedFile: MediaFileData): MediaFileData {
    return uploadedFile
  }

  @Emit('removeFile')
  removeFile(index: number): number {
    return index
  }

  private api: FileApi | null = null

  isDragoverListenerActivated = false

  isOnDroppableZone = false

  currentBrowser = currentBrowser()

  computeType(file:File):FileType {
    if (!this.allDocument) {
      if (file.type.includes('application/')) return FileType.Document
      if (file.type.includes('image/')) return FileType.Image
      if (file.type.includes('video/')) return FileType.Video
      if (file.type.includes('audio/')) return FileType.Audio
    }

    return FileType.Document
  }

  public onFileInputChange(newFiles: Array<File>): void {

    for (const newFile of newFiles) {
      const fileType = this.selectedType ? this.selectedType : this.computeType(newFile)

      const reader = new FileReader()
      reader.addEventListener('load', () => {
        const fileData = FileDataFabric.create({
          guid: Guid.create().toString(),
          file: '',
          type: fileType,
          blobType: newFile.type,
          blobFile: newFile,
          name: newFile.name,
          status: FileStatus.Set,
          preview: '',
          abstractType: fileType,
        })

        this.fileLoaded(fileData)

        if (this.actualFilesData) {
          if (this.actualFilesData.length <= this.filesToUploadLimit) {
            this.uploadFile(fileData, fileType)
          } else {
            warningNotificationWrapper(this.$t('warning').toString(), `${ this.filesToUploadLimit } files limit`)
            this.removeFileFromList(fileData)
          }
        }
      }, false)
      reader.readAsDataURL(newFile)
    }
  }

  // eslint-disable-next-line max-statements
  async uploadFile(fileToUploadData: MediaFileData, uploadType: FileType): Promise<void> {
    const fileToEdit = this.actualFilesData.find((fd) => fd.guid === fileToUploadData.guid)

    if (this.api && fileToEdit) {
      try {
        fileToEdit.status = FileStatus.Loading

        const setProgress = (val: number) => this.$set(fileToEdit, 'progress', val)

        const formData: FormData = new FormData()
        const target = Object.entries(this.getQueryParams())[0]

        formData.append('file', fileToEdit.blobFile, fileToEdit.blobFile.name)
        formData.append(target[0], target[1] as string)
        formData.append('type', uploadType)

        const { data } = await this.api.uploadFile(formData, undefined, setProgress)

        const fileDescriptor = data.file_descriptor
        // eslint-disable-next-line id-blacklist
        fileToEdit.file = fileDescriptor
        fileToEdit.status = FileStatus.Uploaded
        fileToEdit.preview = this.api.getFilePreviewUrl(fileDescriptor, this.getQueryParams().target.toString())
      } catch (error: any) {
        fileToEdit.status = FileStatus.Failed
        errorNotificationWrapper('', error)
        this.removeFileFromList(fileToEdit)
      }
    }
  }

  removeFileFromList(fileData: MediaFileData): void {
    const foundDataIndex = this.actualFilesData.findIndex((fd) => fd.guid === fileData.guid)
    this.removeFile(foundDataIndex)
  }

  getQueryParams(): Record<string, string | number> {
    return {
      target: this.targetToUpload().target_id,
    }
  }

  // eslint-disable-next-line max-statements
  public updated(): void {
    if (!this.isDragoverListenerActivated) {
      const DRAGOVER_ACTIVE_CLASS = 'dragover-active'

      const addActiveClass = (): void => {
        this.droppableZone.classList.add(DRAGOVER_ACTIVE_CLASS)
        this.isOnDroppableZone = true
      }

      const removeActiveClass = (): void => {
        this.droppableZone.classList.remove(DRAGOVER_ACTIVE_CLASS)
        this.isOnDroppableZone = false
      }

      this.droppableZone.addEventListener('dragenter', addActiveClass, false)
      this.droppableZone.addEventListener('dragover', addActiveClass, false)

      this.droppableZone.addEventListener('dragleave', removeActiveClass, false)
      this.droppableZone.addEventListener('dragend', removeActiveClass, false)
      this.droppableZone.addEventListener('drop', removeActiveClass, false)

      // this.droppableZone.addEventListener('drop', (e) => {
      //   this.droppableZone.classList.remove(DRAGOVER_ACTIVE_CLASS)
      //   if (e.dataTransfer !== null) {
      //     this.fileInput.files = e.dataTransfer.files
      //   }
      // }, false)

      this.isDragoverListenerActivated = true
    }
  }

  // eslint-disable-next-line no-undef
  handlePaste(evt:ClipboardEventInit):void {
    if ([ FileType.Image, FileType.MessagePreview, FileType.TopMessagePreview ].includes(this.selectedType)) {
      const { clipboardData } = evt
      if (clipboardData && clipboardData.files.length && clipboardData.files[0].type.includes('image/')) {
        this.onFileInputChange([ clipboardData.files[0] ])
      }
    }
  }

  mounted(): void {
    document.addEventListener('paste', this.handlePaste)
  }

  // handleDrop(e:DragEvent):void {
  //   this.droppableZone.classList.remove(this.DRAGOVER_ACTIVE_CLASS)
  //   if (e.dataTransfer !== null) {
  //     this.fileInput.files = e.dataTransfer.files
  //   }
  // }

  destroyed(): void {
    document.removeEventListener('paste', this.handlePaste)
  }

  created(): void {
    if (this.baseApiUrl) {
      this.api = new FileApi(this.baseApiUrl)
    }
  }
}
